var lib_core       = require("lib-core");
var lib_geometry   = require("lib-geometry");
var cio_datamodel  = require("cio-datamodel");

var PathToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options, toolModel, norec) {
    var self = this;
    this.root = root;

    this.PathClass = options.PathClass;
    this.getDataCollection = getDataCollection;
    this.options = options || {};
    this.mode = options.stateMachineMode || cio_datamodel.PathPointMode.STRAIGHT;

    this.timestamp_previous = 0;
    this.mouseCoord_previous = new lib_geometry.Coord(0,0);

    this.editorModel = editorModel;
    this.selectionModel = selectionModel;

    lib_core.StateMachine.call(this);

    this.handleModel = null;

    this.addEventAction("idle",
        function (cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE);
        },
        function (cEvent) {
            self.editorModel.getSnappedMousePos();
        }
    );

    this.addEventAction("idle",
        function (cEvent) {
            return cEvent.isKeyPressed('escape') || cEvent.type().isGuiButton;
        },
        function (cEvent) {
            self.editorModel.clearSnap();
        }
    );

    this.addTransition("idle","drawing",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN ||
                    cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN ||
                    (cEvent.type() == lib_core.GuiEvents.HANDLE_MOUSE_DOWN));
        },
        function (cEvent) {
            self.selectionModel.emptySelection();
            if(!norec) self.root.rec();

            self.elementData = self.createData();

            var startCoord = self.editorModel.getSnappedMousePos();
            self.elementData.objects.get(0).endpoint(startCoord);
            self.addObject(startCoord);

            self.addDataToCollection();
        }
    );

    this.addTransition("drawing","drawing",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE);
        },
        function (cEvent) {
            var keys = {altKey: cEvent.data('altKey'), shiftKey: cEvent.data('shiftKey')};
            var snapVec = self.editorModel.getSnappedMouseDisplacement([self.handleModel]);
            self.handleModel.move(snapVec, keys);
        }
    );

    this.addTransition("drawing", "drawing",
        function (cEvent) {
            var clickpos_current = cEvent.data('mouseCoord') && self.editorModel.cameraModel().toRealCoord(cEvent.data('mouseCoord'));
            return ((cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN) ||
                    (cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN) ||
                    (cEvent.type() == lib_core.GuiEvents.HANDLE_MOUSE_DOWN)) &&
                    (cEvent.timestamp() - self.timestamp_previous >= 200 ||
                        clickpos_current.distance(self.clickpos_previous) >= self.options.strokeWidth*4);
        },
        function (cEvent) {
            if(!norec) self.root.stopRec();
            self.editorModel.clearSnap();

            if(!norec) self.root.rec();
            self.addObject(self.editorModel.getSnappedMousePos());
            self.handleModel = self.interactionModel.pointHandles.last();
            self.handleModel.highlighted(true);

            self.timestamp_previous = cEvent.timestamp();
            self.clickpos_previous = self.editorModel.cameraModel().toRealCoord(cEvent.data('mouseCoord'));
        }
    );

    this.addTransition("drawing", "idle",
        function (cEvent) {
            var clickpos_current = cEvent.data('mouseCoord') && self.editorModel.cameraModel().toRealCoord(cEvent.data('mouseCoord'));
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN ||
                    cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN ||
                    (cEvent.type() == lib_core.GuiEvents.HANDLE_MOUSE_DOWN)) &&
                    (cEvent.timestamp() - self.timestamp_previous < 200
                        && clickpos_current.distance(self.clickpos_previous) < self.options.strokeWidth*4);
        },
        function (cEvent) {
            self.elementData.objects.remove(self.elementData.objects.size()-1);

            if( self.elementData.objects.size() > 1 &&
                self.elementData.objects.get(0).endpoint().x == self.elementData.objects.last().endpoint().x &&
                self.elementData.objects.get(0).endpoint().y == self.elementData.objects.last().endpoint().y)
            {
                self.removeLastObject();
                self.elementData.closed(true);
            }

            if(!norec) self.root.stopRec();

            self.editorModel.clearSnap();
            self.selectionModel.addToSelection(self.interactionModel);
        }
    );

    this.addTransition("drawing","idle",
        function(cEvent) {
            return (cEvent.isKeyPressed('escape') || cEvent.type().isGuiButton);
        },
        function (cEvent) {
            if(!norec) self.root.cancelRec();
            self.editorModel.clearSnap();
            self.handle(cEvent);
        }
    );

    this.addTransition("drawing","drawing",
        function(cEvent) {
            return (cEvent.isKeyPressed('backspace'));
        },
        function (cEvent) {
            if(self.interactionModel.segments.size() > 1 && self.interactionModel.pointHandles.size() > 2) {

                /**
                 * imagine we have 3 coords, A ---- B ---- C
                 * we are deleting segment B-C ... and instead of C being active,
                 * now B is .. but for B to be in the right position, and because
                 * we do not use absolute positions but change vectors, we have to
                 * now save the vector C-B so that when C is gone, B can be repositioned
                 * to C's old location (which is where the mouse is)
                 */
                var sz = self.interactionModel.pointHandles.size();
                var handleC = self.interactionModel.pointHandles.get(sz-1).coord();
                var handleB = self.interactionModel.pointHandles.get(sz-2).coord();
                var saveVec = handleC.sub(handleB);

                // we want to cancel the last path saved and save this deletion
                self.removeLastObject();
                self.interactionModel.pointHandles.last().coord(
                    self.interactionModel.pointHandles.last().coord().add(saveVec)
                );

                //self.timestamp_previous = new Date().getTime();  needed?

                sz = handleB = handleC = saveVec = null; // cleanup
            }
        }
    );

};
lib_core.inherit(PathToolStateMachine, lib_core.StateMachine);

module.exports = PathToolStateMachine;

PathToolStateMachine.prototype.createData = function(){
    return new this.PathClass(new lib_geometry.Coord(0,0), this.options.strokeWidth, null, this.options.fill, false);
};

PathToolStateMachine.prototype.addDataToCollection = function(){
    this.elementData.addTo(this.getDataCollection());

    this.interactionModel = this.editorModel.interactionModelDataMap.get(this.elementData);
    if(this.interactionModel) {
        this.interactionModel.setFocus(true);
        this.handleModel = this.interactionModel.pointHandles.last();
        this.handleModel.highlighted(true);
    }
};

PathToolStateMachine.prototype.addObject = function(coord){
    var type = (this.mode == cio_datamodel.PathPointMode.STRAIGHT) ? cio_datamodel.PathType.LINE : cio_datamodel.PathType.CURVEC;
    var object = new cio_datamodel.PathObjectData(coord, type);
    object.tan_0(coord);
    object.tan_1(coord);

    this.elementData.addObject(object);

    return object;
};

PathToolStateMachine.prototype.removeLastObject = function () {
    if (this.elementData.objects.size() > 2) {
        this.elementData.objects.remove(this.elementData.objects.size()-1);
    } else {
        this.elementData.remove();
    }
};
